<template>
    <div style="width: 100%;" class="notranslate">
        <div
            class="oddsBoxWrapper"
            v-bind:class="{
                'flex-row': layout === MatchDetailLayout.column,
                'flex-column': layout === MatchDetailLayout.row,
            }"
        >
            <div
                v-for="(group, index) in selectionLayout"
                v-bind:key="index"
                class="oddsBoxPack"
                v-bind:class="{
                    'flex-row': layout === MatchDetailLayout.row,
                    'flex-column': layout === MatchDetailLayout.column,
                    'two-per-row': isTwoPerRow,
                }"
            >
                <div v-if="group.title" class="title">
                    {{ group.title }}
                </div>
                <Selection
                    v-for="selection in group.selections"
                    v-bind:key="selection.id"
                    v-bind:market="market"
                    v-bind:selection="selection"
                    v-bind:match="match"
                    v-bind:isSingleColumn="isSingleColumn"
                    v-bind:displaySection="displaySection"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent, toRefs } from 'vue';
    import Selection from '@/components/betBuilder/Selection.vue';
    import type { IMatch } from '@/interface/IMatch';
    import type { IBetBuilderMarket } from '@/interface/betBuilder';
    import { DisplaySection } from '@/interface/enum';
    import { MatchDetailLayout, getMarketRule, isSingleColumnDisplay, isTwoPerRowDisplay } from '@/libraries/oddsApi/betBuilderMarketRule';

    export default defineComponent({
        name: 'BetBuilderMarket',
        components: {
            Selection,
        },
        props: {
            market: {
                type: Object as PropType<IBetBuilderMarket>,
                required: true,
            },
            match: {
                type: Object as PropType<IMatch>,
                default: () => ({}),
            },
            displaySection: {
                type: Number as PropType<DisplaySection>,
                default: DisplaySection.Unknown,
            },
        },
        setup(props) {
            const { market } = toRefs(props);
            const marketRule = computed(() => getMarketRule(market.value.displayType));
            const { layout, matchDetailLayout } = marketRule.value;
            const selectionLayout = computed(() => matchDetailLayout(market.value));
            const isSingleColumn = computed(() => isSingleColumnDisplay(market.value.displayType));
            const isTwoPerRow = computed(() => isTwoPerRowDisplay(market.value.displayType));

            return {
                MatchDetailLayout,
                layout,
                selectionLayout,
                isSingleColumn,
                isTwoPerRow,
            };
        },

    });
</script>

<style scoped lang="scss">
    .flex-row {
        width: 100%;
        flex-direction: row;
        justify-content: space-around;
    }

    .flex-column {
        flex-direction: column;
    }

    .title {
        display: flex;
        justify-content: center;
    }

    .oddsBoxWrapper {
        display: flex;
        justify-content: flex-start;
    }

    .oddsBoxPack {
        display: flex;
        min-width: 0;
        flex: 1;
        justify-content: flex-start;
    }

    .oddsBoxPack.two-per-row {
        flex-wrap: wrap;

        > .oddsBox {
            max-width: 50%;
            flex: 0 0 50%;
        }
    }
</style>
